import { PayloadAction, createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getOrganizations } from "../../utilities/api-utils";

interface OrganizationState {
  organizations: string[],
  loading: boolean,
  activeOrganization: string
}

const initialState: OrganizationState = {
  // state default values
  organizations: [],
  loading: false,
  activeOrganization: ""
};

export const fetchOrganizations = createAsyncThunk(
  'organizations/fetchOrganizations',
  async (key: string, { signal }) => {
    const source = axios.CancelToken.source();

    signal.addEventListener('abort', () => {
      source.cancel();
    });
    
    const response = await getOrganizations(key);
    return response.data;
  }
);

export const organizationSlice = createSlice({
  name: 'Organization',
  initialState,
  reducers: {
    // actions for setting state
    setOrganizations: (state, action: PayloadAction<string[]>) => {
      state.organizations = action.payload;
    },
    setActiveOrganization: (state, action: PayloadAction<string>) => {
      state.activeOrganization = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchOrganizations.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchOrganizations.fulfilled, (state, action) => {
      state.loading = false;
      state.organizations.length = 0;
      for (let i = 0; i < action.payload.length; i++) {
        state.organizations.push(action.payload[i].id);
      }
    });
    builder.addCase(fetchOrganizations.rejected, (state) => {
      state.loading = false;
    });
  }
});

export const { setOrganizations, setActiveOrganization/* destructure actions */ } = organizationSlice.actions;
export default organizationSlice.reducer;
